/**
 * Settlement Repository Interface
 */
export class ISettlementRepository {
  async getSummary(pharmacyId, startDate, endDate) {
    throw new Error('Method must be implemented');
  }

  async getPgPayments(pharmacyId, startDate, endDate, params) {
    throw new Error('Method must be implemented');
  }

  async getPointTransactions(pharmacyId, startDate, endDate, params) {
    throw new Error('Method must be implemented');
  }

  async getCouponUsages(pharmacyId, startDate, endDate, params) {
    throw new Error('Method must be implemented');
  }

  async getDaily(month) {
    throw new Error('Method must be implemented');
  }

  async getPaypointKpi(month) {
    throw new Error('Method must be implemented');
  }
}
